import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Calculator from './components/Calculator';
import Services from './components/Services';
import About from './components/About';
import SiniestradosInfo from './components/SiniestradosInfo';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from '../../components/feature/WhatsAppButton';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <h1 className="sr-only">Desguace en Castelldefels - Vende tu Coche al Mejor Precio</h1>
      <Navbar isScrolled={isScrolled} />
      <main>
        <Hero />
        <Calculator />
        <Services />
        <About />
        <SiniestradosInfo />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
